import { bootstrapApplication } from "@angular/platform-browser";
import * as Sentry from "@sentry/angular";
import { posthog } from "posthog-js";
import { AppComponent } from "./app/app.component";
import { createAppConfig } from "./app/app.config";
import { resolveBrand } from "./app/shared/branding/brand-resolver";
import "./app/shared/patches/quillNbspFix";
import "./app/shared/patches/quillBlotFormatter";
import { environment } from "./environments/environment";

if (environment.sentry.enabled) {
  Sentry.init({
    dsn: environment.sentry.dsn,
    environment: environment.sentry.environment,
  });
}

if (environment.posthog.enabled) {
  posthog.init(environment.posthog.posthogKey, {
    api_host: environment.posthog.posthogHost,
    person_profiles: "identified_only",

    // Use new defaults instead of "legacy" options (from Posthog docs)
    defaults: "2025-05-24",
  });
}

const brand = resolveBrand();
const appConfig = createAppConfig(brand);

bootstrapApplication(AppComponent, appConfig).catch((err) => console.error(err));
